import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';



if (environment.production) {
  enableProdMode();

  // Manual service worker registration (compatible with Angular 18)
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/ngsw-worker.js')
      .then(() => console.log('Service worker registered'))
      .catch(err => console.log('Service worker registration failed'));
  }
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
